/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import { capitalize } from '@ember/string';

export default buildHelper(function ([array]) {
  let stringArray = array || [''];
  return stringArray.map((word) => capitalize(word));
});
